import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { INDIAN_STATES, StateOption } from "../../../constants/state";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useStyles } from "./StateDropDown.style";

interface IStateDropDownProps {
  value?: string;
  onSelectState: (state: StateOption) => void;
}

const StateDropDown: FC<
  IStateDropDownProps & Omit<HTMLAttributes<HTMLDivElement>, "onSelect">
> = (props) => {
  const classes = useStyles();
  const { value, onSelectState, className, ...otherProps } = props;

  return (
    <div {...otherProps} className={clsx(classes.container, className)}>
      {INDIAN_STATES.map((state, idx) => (
        <div
          className={clsx(classes.option, {
            [classes.selected]: value === state.value,
          })}
          data-gamepad={`state-${idx}`}
          data-selected-class={classes.selected}
          data-native-scroll
          onClick={() => onSelectState(state)}
          key={state.value}
        >
          <Typography variant={TypographyVariant.BodyB5Medium}>
            {state.label}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default StateDropDown;
